export var QuantityInput = function () {
    'ngInject';
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, $element, $attrs, ngModel) {
            $element.on('keydown', function (e) {
                var key = e.key || '';
                if ($element.val().length === 0 && parseInt(key) === 0) {
                    e.preventDefault();
                }
                else if (e.keyCode === 8 || e.keyCode === 46 ||
                    e.keyCode === 37 || e.keyCode === 39 ||
                    e.keyCode === 9 || key.match(/^[0-9]+$/) != null) {
                    return;
                }
                else if (e.charCode === 8 || e.charCode === 46 ||
                    e.charCode === 37 || e.charCode === 39 ||
                    e.charCode === 9 || key.match(/^[0-9]+$/) != null) {
                    return;
                }
                else {
                    e.preventDefault();
                }
            });
            $element.on('keyup', function (e) {
                if (parseInt($element.val()) === 0) {
                    $element.val('');
                    ngModel.$setViewValue('');
                    ngModel.$setUntouched();
                    ngModel.$setPristine();
                }
            });
        }
    };
};
//# sourceMappingURL=quantity-input.directive.js.map